import { Card } from '#/shared/components/Card';
import { useTimesheetStore } from '#/shared/stores/timesheetStore';

export function TimesheetAdditionalInfo() {
  const additionalInfo = useTimesheetStore(state => state.timesheet?.additionalInfo);

  if (!additionalInfo) {
    return null;
  }

  return (
    <div className="flex flex-col gap-8">
      <h3 className="text-14 block">Comments for approver</h3>
      <Card>{additionalInfo}</Card>
    </div>
  );
}
